var _defs, _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHamsLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 585.61 147.02",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#4dbded;}.cls-3{fill:#8158fc;mix-blend-mode:multiply;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "etiketTekengebied 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 9.48,
    width: 80.95,
    height: 100.53,
    rx: 40.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.13,144.78h-15a5,5,0,0,1-5-5V83.92c0-53,80.82-53,80.82,0h0A60.86,60.86,0,0,1,20.13,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.52,61.08c-15.35,0-22,15.3-22,31v52.64H123V12.68h8.75c8.55,0,12.82,4.46,12.82,13V56.38C157.78,41.23,173.72,37.74,189,43.75c14.23,5.62,21.17,19,20.39,41.37v59.63H187.88V92.11C187.88,74.83,181.28,61.08,166.52,61.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,68.81H230.78c3.11-19,20.61-28.36,36.93-28.36,20.44,0,39.91,9.32,40.49,28.36l.52,34.81c0,28.35-14.79,41.13-42.57,43.07-24.66,1.94-41.76-9.52-41.76-32.24.59-24.67,18.46-31.27,44.48-33.8,11.07-1.36,16.7-4.66,16.7-10.29-.58-5.83-6-8.74-16.7-8.74C259.74,61.62,254.69,64,253.33,68.81ZM287,102.3l-.28-11.7a126.68,126.68,0,0,1-22,7c-10.3,2-17.27,6.13-17.27,16.16a15,15,0,0,0,14.76,15C281.19,128.76,287,116.87,287,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.68,79.1v65.65l-23.21.28V84.62c0-29.33,16.15-43,42.06-43.31,13.21-.15,23.31,3.92,30.69,9.75,7.38-5.64,17.08-9.19,30.29-9.19,24.11,0,42.25,13.53,42.05,42.86v60.41H460.29c-8.55-.59-12.82-4.67-12.82-12.82V79.49c-.59-10.68-7.49-16.91-19-16.91s-18.75,6.5-18.95,17.19V145l-23.09-.28V79.1c-.58-10.68-7.88-17.6-19.33-17.6S348.88,68.42,348.68,79.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531,127.36c10.87,0,18.16-4.54,17.82-11.14-.37-7.2-8.62-11.65-26.29-14.76C499.84,97.38,487.86,85.58,488,72.3c.23-22.14,16-31.46,39.46-31.85,13.21,0,22.81,3.11,30.58,8.94,7.58,6,11.7,13.26,12.29,24l-16.19-.08c-6-.19-8.47-1.42-10-5.49-1.75-4.47-7.89-7.8-16.43-7.8-10.1,0-15.88,3.67-15.88,8.91s7.07,11.69,20.47,14.22c17.48,3.49,27.85,8.79,33.48,14,4.85,5,6.48,9.21,6.48,16.2,0,21.6-16.81,33-44,33-14.37,0-25.31-3.17-32.3-9.19-7.77-5.83-10.86-14.33-10.86-26.18h23.67C509.33,122.2,518.4,127.36,531,127.36Z"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHamsLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hams_logo.2d3ceb6e.svg";
export { ForwardRef as ReactComponent };